/*
  TensCare cart drawer helpers — Notes / Coupon popovers (Figma node 74-3364)
  and the free-shipping progress bar.

  The drawer markup is re-rendered wholesale on every cart mutation, so all
  behaviour here is bound through event delegation on `document`.
*/
(function () {
  'use strict';

  var DRAWER = 'cart-drawer';

  function closePopover(pop) {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    var name = pop.getAttribute('data-tcs-popover');
    var toggle = document.querySelector('[data-tcs-toggle="' + name + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllPopovers() {
    document.querySelectorAll('[data-tcs-popover]').forEach(closePopover);
  }

  function openPopover(name) {
    var pop = document.querySelector('[data-tcs-popover="' + name + '"]');
    if (!pop) return;
    document.querySelectorAll('[data-tcs-popover]').forEach(function (other) {
      if (other !== pop) closePopover(other);
    });
    pop.hidden = false;
    var toggle = document.querySelector('[data-tcs-toggle="' + name + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var field = pop.querySelector('textarea, input');
    if (field) {
      requestAnimationFrame(function () {
        field.focus();
      });
    }
  }

  // Stepping the quantity below 1 removes the line (no trash icon in the design).
  // Capture phase so we can pre-empt <quantity-input>'s own button handler.
  document.addEventListener(
    'click',
    function (event) {
      var minus = event.target.closest('.cart-item__step[name="minus"]');
      if (!minus) return;
      var stepper = minus.closest('quantity-input');
      var input = stepper && stepper.querySelector('input');
      if (!input) return;
      var min = parseInt(input.dataset.min, 10) || 1;
      if (parseInt(input.value, 10) > Math.max(min, 1)) return;

      var row = minus.closest('.cart-item');
      var removeBtn = row && row.querySelector('cart-remove-button button');
      if (!removeBtn) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      removeBtn.click();
    },
    true
  );

  // Robust click-outside-to-close: fires regardless of whether cart-drawer.js
  // managed to (re)bind its own overlay listener after a section re-render.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('#CartDrawer-Overlay')) return;
    var drawer = document.querySelector(DRAWER);
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else if (drawer) {
      drawer.classList.remove('active', 'animate');
      document.body.classList.remove('overflow-hidden');
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-tcs-toggle]');
    if (toggle) {
      event.preventDefault();
      var name = toggle.getAttribute('data-tcs-toggle');
      var pop = document.querySelector('[data-tcs-popover="' + name + '"]');
      if (pop && !pop.hidden) {
        closePopover(pop);
      } else {
        openPopover(name);
      }
      return;
    }

    if (event.target.closest('[data-tcs-close]')) {
      event.preventDefault();
      closePopover(event.target.closest('[data-tcs-popover]'));
      return;
    }

    var applyBtn = event.target.closest('[data-tcs-coupon-apply]');
    if (applyBtn) {
      event.preventDefault();
      applyCoupon(applyBtn);
      return;
    }

    // click outside any popover but inside the drawer closes the popover
    if (
      !event.target.closest('[data-tcs-popover]') &&
      !event.target.closest('[data-tcs-toggle]') &&
      event.target.closest('.cart-drawer__footer')
    ) {
      closeAllPopovers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-tcs-popover]:not([hidden])');
    if (open) {
      event.stopPropagation();
      closePopover(open);
    }
  });

  // close popovers whenever the drawer is dismissed
  function watchDrawer() {
    var drawer = document.querySelector(DRAWER);
    if (!drawer) return;
    new MutationObserver(function () {
      if (!drawer.classList.contains('active')) closeAllPopovers();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------------------------------------------------------------- coupon
  function couponRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/discount/';
  }

  function applyCoupon(btn) {
    var pop = btn.closest('[data-tcs-popover]');
    var input = pop && pop.querySelector('#CartDrawer-Coupon');
    var msg = pop && pop.querySelector('.cart-drawer__coupon-msg');
    var code = input ? input.value.trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }

    function setMsg(text, state) {
      if (!msg) return;
      msg.textContent = text;
      msg.setAttribute('data-state', state);
      msg.hidden = false;
    }

    btn.setAttribute('aria-busy', 'true');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(couponRoot() + encodeURIComponent(code), { method: 'GET', headers: { Accept: 'text/html' } })
      .then(function () {
        return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        var match = codes.filter(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase();
        })[0];
        var applied =
          (match && match.applicable) ||
          (cart.cart_level_discount_applications || []).some(function (d) {
            return (d.title || '').toUpperCase() === code.toUpperCase();
          });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-coupon', cartData: cart });
        }

        if (applied) {
          setMsg('Discount “' + code.toUpperCase() + '” applied.', 'success');
          window.setTimeout(function () {
            closeAllPopovers();
          }, 1100);
        } else {
          setMsg('“' + code.toUpperCase() + '” is not a valid discount code.', 'error');
        }
      })
      .catch(function () {
        setMsg('Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
